import Overlay from './classes/Overlay';
import scrollBreakpoints from './classes/scrollBreakpoints';
import { onDomReady } from './includes/utils';
//import HorizontalList from './classes/HorizontalList';
//import PerfectScrollbar from "./vendors/perfect-scrollbar-1.4/dist/perfect-scrollbar.esm";
import GMap from "./maps";
//import './includes/scrollable';
import './proto/Window-getViewportDimensions';
import './proto/Element-getPosition';
import './app-forms';

//import './scrollBehavior';

(function() {
	document.querySelectorAll('a.overlay-link').forEach(a => {
		a.addEventListener('click', event => { 
			event.preventDefault();
			const overlay = new Overlay();
			overlay.openAjax( a.getAttribute('href') );
		});
	});
	
	document.querySelectorAll('a.overlay-inline-link').forEach(a => {
		if(! a.dataset.ref ) {
			return;
		}
		const ref = document.querySelector(a.dataset.ref);
		if(! ref ) {
			return;
		}
		console.log(ref);
		a.addEventListener('click', event => { 
			event.preventDefault();
			const overlay = new Overlay();
			overlay.opentHtmlElement(ref);
		});
	});
}());


(function() {
	document.querySelector('.site-culture-selector').addEventListener('click', event => {
		if( event.target.tagName.toUpperCase() === 'A' )
			return;
		
		event.preventDefault();
		event.currentTarget.classList.toggle('shown');
	});
}());




function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

	
	
(function() {
	onDomReady(() => {
		if( typeof(tarteaucitron) === 'undefined' )
			return;
		
		var tarteaucitronForceLanguage = locale;
		tarteaucitron.init({
			'privacyUrl': privacy_url, 
			'hashtag': '#services-manager',
			'cookieName': 'servicesmanager',
		    
		    'orientation': 'bottom', /* Banner position (top - bottom) */
		    'showAlertSmall': false, /* Show the small banner on bottom right */
		    'cookieslist': true, /* Show the cookie list */
		
		    'adblocker': false, /* Show a Warning if an adblocker is detected */
		    'AcceptAllCta' : true, /* Show the accept all button when highPrivacy on */
		    'highPrivacy': true, /* Disable auto consent */
		    'handleBrowserDNTRequest': false, /* If Do Not Track == 1, disallow all */
		
		    'removeCredit': true, /* Remove credit link */
		    'moreInfoLink': true /* Show more info link */
	    });
	    
	    /*
		tarteaucitron.user.gtagUa = gTagUA;
		tarteaucitron.user.gtagMore = function () { /* add here your optionnal gtag() * / };
		(tarteaucitron.job = tarteaucitron.job || []).push('gtag');
		*/
		tarteaucitron.user.multiplegtagUa = [gTagUA, 'AW-732883246'];
		(tarteaucitron.job = tarteaucitron.job || []).push('multiplegtag');
		
		tarteaucitron.user.googlemapsKey = gApiKey;
		(tarteaucitron.job = tarteaucitron.job || []).push('googlemaps');
		
		tarteaucitron.user.googletagmanagerId = 'GTM-MZ8ZWDJ';
		(tarteaucitron.job = tarteaucitron.job || []).push('googletagmanager');
		
		tarteaucitron.user.facebookpixelId = '3361649287240586'; 
		tarteaucitron.user.facebookpixelMore = function () { /* add here your optionnal facebook pixel function */ };
		(tarteaucitron.job = tarteaucitron.job || []).push('facebookpixel');
        
		tarteaucitron.user.linkedinadsPartnerId = '1718012';
		tarteaucitron.user.linkedinadsMore = function () { /* add here your optionnal linkedin ads function */ };
		(tarteaucitron.job = tarteaucitron.job || []).push('linkedinads');
		
	});
})();




/*
 * Scrolling breakpoints 
 */
(function() {
	const breakPoints = [];
	/*
		{ 
			breakpoint: 120,
			callBack: {
				UP: function(element) {
					document.querySelector('.site-top-bar').classList.remove('min');
					document.querySelector('body').classList.remove('scrolled');
					document.querySelector('.site-controls').classList.remove('min');
				},
				
				DOWN: function(element) {
					document.querySelector('.site-top-bar').classList.add('min');
					document.querySelector('body').classList.add('scrolled');
					document.querySelector('.site-controls').classList.add('min');
				}
			}
		},
	];
	*/
	
	const scrollBP = new scrollBreakpoints(breakPoints);
	scrollBP.addBreakpoint({ 
		breakpoint: document.querySelectorAll('.fade-in'),
		callBack: {
			DOWN: function() {
				this.element.classList.add('shown');
			}
		}
	});
})();



// User Addresses
(function() {

	document.querySelectorAll('ul.profile-addresses .delete-btn').forEach(button => { 
		button.addEventListener('click', event => {
			event.preventDefault();
			
			const button = event.currentTarget;
			if( button.dataset.confirm ) {
				if(! confirm(button.dataset.confirm))
					return;
			}
			
			const holder = button.closest('.address-item');
			const csrf = document.querySelector('meta[name="csrf-token"]');
			const headers = csrf ? new Headers({'X-CSRF-Token': csrf.getAttribute('content')}) : new Headers();
			const form = document.getElementById( 'delete-address-'+ button.dataset.id);
			const url = form.getAttribute('action');
			
			const params = {
				method: 'POST',
				body: new FormData(form),
				headers: headers
			};

			fetch(url, params).then( response => response.json() ).then(json => {
				if( json.code !== 200 ) 
					return alert('There was an error');
				
				const listHolder = holder.parentNode;
				listHolder.removeChild(holder);
				const total = listHolder.querySelectorAll('.address-item').length;
				if( total === 0 )
					document.location.reload();
			})
		});
	});
}());



(function() {
	document.querySelectorAll('.button-as-link[data-href]').forEach(button => {
		button.addEventListener('click', event => {
			document.location.href = button.dataset.href;
		});
	});
}());




(function() {
	if( typeof(cart_status_url) === 'undefined' )
		return;
	
	if( document.body.classList.contains('order') )
		return;
	
	fetch(cart_status_url).then(response => response.json()).then(json => {
		if( json.code !== 200 || json.count === 0 )
			return;
		
		const holder = document.createElement('div');
		holder.classList.add('cart-status-holder');
		holder.innerHTML = json.body;
		document.body.appendChild(holder);
	});
}());



